enum ModulEnum {
    HastaKayitKabul = 1,
    Tedavi = 2,
    Vezne = 3,
    GuvenlikTanim = 4,
    Randevu = 5,
    FaturaModulu = 6,
    Alis = 99,
    YatisKabul = 1117947291,
    KargoKuryeTakip = 1117970676,
    Patoloji = 1117969837,
    Muhasebe = 1222047131,
    Radyoloji = 1117969838,
    SonucIzleme = 8,
    Stok = 9
}
export default ModulEnum;